import {
  Box, Container, Flex, VStack
} from "@chakra-ui/react";
import parse from "html-react-parser";
import React, { useState } from "react";
import { NftResource } from "../../../components/NftResource";
import { IMoralisNft } from "../../../core/models/nft";
import { useTranslation } from "react-i18next";
import { I18N_NAMESPACE } from "../../../core/constants/i18n";
import { AssetPreviewModal } from "./AssetPreviewModal";
import ExpandableText from "../../../components/ExpandableText";

interface Props {
  nft: IMoralisNft | undefined;
  notes?: string;
  setNotes?: (value: string) => void;
  disablesNotes?: boolean;
  isOwner: boolean;
  maxMediaHeight?: string;
}

export const AssetPrimaryInfo = ({ nft, notes, setNotes, disablesNotes: disabledNotes, isOwner, maxMediaHeight }: Props) => {
  const { t } = useTranslation([I18N_NAMESPACE.ASSET_DETAIL]);
  const [isVisiblePreview, setIsVisiblePreview] = useState(false);
  return (
    <Box>
      <Box
        onClick={(e: any) => { e.preventDefault(); setIsVisiblePreview(true) }}
        cursor={"zoom-in"}
      >
        <NftResource 
          image={nft?.metadata?.image} 
          animationUrl={nft?.metadata?.animation_url} 
          showVideoControls muted maxH={maxMediaHeight}/>
      </Box>

      <Box py={5} cursor={"default"}>
        <ExpandableText visibleLines={3} collapedButtonText={t("[Show more]")} expandedButtonText={t("[Show less]")} >
          {!!nft?.metadata?.description && parse(nft?.metadata?.description)}
        </ExpandableText>
      </Box>

      {!!nft && <AssetPreviewModal nft={nft} isVisible={isVisiblePreview} onClose={() => setIsVisiblePreview(false)} />}
    </Box>
  );
};
